"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "0 1.5rem",
            backgroundColor: "#0a0a0a",
            color: "white",
            textAlign: "center",
            gap: "1rem",
          }}
        >
          <h2 style={{ fontSize: "2rem" }}>Something went wrong</h2>
          <p style={{ fontSize: "0.875rem", opacity: 0.6, maxWidth: "28rem" }}>
            An unexpected error occurred. Please refresh the page.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              height: "44px",
              padding: "0 20px",
              borderRadius: "12px",
              backgroundColor: "#626e58",
              color: "white",
              fontSize: "14px",
              fontWeight: 600,
              border: "none",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
